import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { AbstractSelect } from '@components/field_form/selects/abstract-select';
import {AbstractClass, FormCell} from '@classes/abstract.class';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { LocationService } from "@services/admin/location.service";
import {WorkScheduleService} from "@services/admin/work-schedule.service";
import {Images} from "@constants/images";
import {Location} from "@models/location";

@Component({
  standalone: false,
  selector: 'app-field-form-select-location',
  templateUrl: './select-location.component.html',
  styleUrls: ['./select-location.component.scss'],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'overlay_custom_select' }
    }
  ]
})
export class SelectLocationComponent extends AbstractSelect implements OnInit {
  @Input() public myClass: AbstractClass | null = null;
  @Input() label = '';
  @Input() name = '';
  @Input() required = false;
  @Input() filter = false;
  @Output() changeAction = new EventEmitter();
  public title: string;
  private create: boolean = true;
  public createLocation: boolean = false;
  public imageClose = Images.close;
  public error = false;
  public errors: any[] = [];
  public fieldForms: FormCell[] = [];
  public list: any[] = [];
  public showList: boolean = true;
  public selectTemporal: any[] = [];
  public center: google.maps.LatLngLiteral = {
    lat: 0,
    lng: 0
  };
  public zoom = 17;
  public markerOptions: google.maps.MarkerOptions = {
    draggable: false
  };
  public positionReady: boolean = true;
  public positionReload: boolean = true;

  constructor(
    public service: LocationService
  ) {
    super(service);
    this.title = this.service.modelClass.langBase + 'title';
    this.fieldForms = this.service.modelClass.getInputsForm();
  }

  ngOnInit(): void {
    this.loadData();
  }

  public loadData = () => {
    this.service.getAll().then(
      (data) => {
        if (data === true) {
          this.list = this.service.data.data;
          this.showList = true;
          this.setCenter();
        }
      }
    );
  }

  public onChange = (event: any, name: string) => {
    console.log("TEST1");
    if (name === 'locationID') {
      this.setValues(this.list.filter(t => t.locationID === event.value)[0]);
    } else if (name === 'latitude') {
      this.setCenter();
    } else if (name === 'longitude') {
      this.setCenter();
    } else {
      this.service.modelClass.model.latitude = event.lat;
      this.service.modelClass.model.longitude = event.lng;
    }
  }

  public setCenter = () => {
    this.positionReload = false;
    this.positionReady = false;
    if (this.myClass !== null) {
      this.center.lat = Number(this.myClass.model.latitude);
      this.center.lng = Number(this.myClass.model.longitude);
      setTimeout(() => {
        this.positionReload = true;
        this.positionReady = true;
      }, 200);
    }
  }

  sendForm(event: any): void {
    event.preventDefault();
    const self = this;
    self.error = self.service.modelClass.getInputsErrors();
    self.errors = self.service.modelClass.getErrors();
    if (!self.error) {
      if (self.create) {
        self.service.create().then((response) => {
          if (response) {
            self.showList = false;
            self.setValues(self.service.data.data);
            self.loadData();
            self.close();
            // self.close(true);
          }
        });
      }
    }
  }

  public close = () => {
    this.createLocation = false
  }

  public setValues = (l: Location) => {
    this.positionReady = false;
    if (this.myClass !== null) {
      this.myClass.model.latitude = l.latitude;
      this.myClass.model.longitude = l.longitude;
      this.myClass.model.locationID = l.locationID;
      this.myClass.model.location = l;
      this.center.lat = this.myClass.model.latitude;
      this.center.lng = this.myClass.model.longitude;
      setTimeout(() => {
        this.positionReady = true;
      }, 200);
    }
  }
}
